import {
	Component,
	EventEmitter,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import {
	AbstractControl,
	FormBuilder,
	FormGroup,
	Validators,
} from '@angular/forms';
import { Locality } from 'src/app/models/apis/catalogs';
import {
	AddressDetails,
	AddressType,
} from 'src/app/models/onboarding/applicant-address.model';
import { ValueDescription } from 'src/app/models/shared/custom-dictionaries';
import { CatalogsService } from 'src/app/services/apis/catalogs.service';
import { ExactLength } from 'src/app/validators/exact-length';

@Component({
	selector: 'cmv-add-address',
	templateUrl: './add-address.component.html',
	styleUrls: ['./add-address.component.scss'],
})
export class AddAddressComponent implements OnInit, OnDestroy {
	addressForm: FormGroup;
	isSearchColonyLoading: boolean = false;
	colonies: ValueDescription<number>[] = [];
	@Output() selectedAddress: EventEmitter<AddressDetails> = new EventEmitter();
	@Output() closeSelectedAddress: EventEmitter<void> = new EventEmitter();

	constructor(
		private formBuilder: FormBuilder,
		private catalogsService: CatalogsService
	) {
		this.addressForm = this.formBuilder.group({
			street: ['', [Validators.required]],
			exteriorNumber: ['', [Validators.required]],
			interiorNumber: [''],
			postalCode: ['', [Validators.required, ExactLength(5)]],
			colonyId: [{ value: '', disabled: true }, Validators.required],
		});
	}
	ngOnDestroy(): void {
		document.body.style.overflow = '';
	}
	ngOnInit(): void {
		document.body.style.overflow = 'hidden';
	}

	get streetField(): AbstractControl {
		return this.addressForm.get('street');
	}

	get exteriorNumberField(): AbstractControl {
		return this.addressForm.get('exteriorNumber');
	}

	get interiorNumberField(): AbstractControl {
		return this.addressForm.get('interiorNumber');
	}

	get postalCodeField(): AbstractControl {
		return this.addressForm.get('postalCode');
	}

	get colonyIdField(): AbstractControl {
		return this.addressForm.get('colonyId');
	}

	onPostalCodeChange(): void {
		if (this.postalCodeField.invalid) {
			this.resetValuesFromPostalCode();
			return;
		}
		this.getColonies();
	}

	resetValuesFromPostalCode(): void {
		this.colonies = [];
		this.colonyIdField.setValue('');
		this.colonyIdField.disable();
	}

	getColonies(): void {
		this.isSearchColonyLoading = true;
		this.postalCodeField.disable();
		this.catalogsService
			.getCityWithColoniesByPostalCode(this.postalCodeField.value)
			.subscribe({
				next: (city: Locality) => {
					this.isSearchColonyLoading = false;
					this.postalCodeField.enable();
					this.colonies = city.Colonias.map(colony => ({
						value: colony.Id_Colonia_CNBV,
						description: colony.Nombre_Colonia,
					}));
					this.colonies = this.colonies.filter(function (colonia) {
						return (
							colonia.description !== null &&
							colonia.description !== undefined &&
							colonia.description !== ''
						);
					});
					this.colonyIdField.enable();
				},
				error: _ => {
					this.isSearchColonyLoading = false;
					this.postalCodeField.enable();
				},
			});
	}

	onCloseSelectAddress(): void {
		this.closeSelectedAddress.emit();
	}

	onSubmitAddress(): void {
		if (this.addressForm.invalid) {
			this.addressForm.markAllAsTouched();
			return;
		}

		const address: AddressDetails = {
			addressType: AddressType.OTHER,
			street: this.streetField.value,
			exteriorNumber: this.exteriorNumberField.value,
			interiorNumber: this.interiorNumberField.value ?? '',
			postalCode: this.postalCodeField.value,
			colony:
				this.colonies.find(colony => colony.value === this.colonyIdField.value)
					.description ?? '',
			colonyId: this.colonyIdField.value,
		};

		this.selectedAddress.emit(address);
	}
}
